/**
 * 音のきっかけ（索引 Issue #498 の段階 2。設計文書 §5）。**純関数**。
 *
 * 型が `sounds(payload, item)` で「帯の頭から何 ms 後にどの音か」を返し、ここが**いつ鳴らすか**の一覧にする。
 * 実際に鳴らすのは `AudioPort`（プレビューは `editorPorts/webAudio.js`、書き出しは fx-export が ffmpeg で混ぜる）。帯を動かせば音も付いてくる。
 *
 * **同じ時刻の同じ音は 1 本にまとめる**（同じ応答で複数枚が同時に壊れるようなとき、枚数ぶん重なって音量が増えないように）。
 */
export function buildCues(items = [], registry) {
  const out = new Map();
  for (const item of items) {
    if (item.hidden) continue;
    const spec = registry?.get?.(item.type);
    if (typeof spec?.sounds !== 'function') continue;
    for (const cue of spec.sounds(item.payload, item) ?? []) {
      if (!cue?.name) continue;
      // `at` は帯の頭からの ms
      const ms = Math.round(item.startMs + (cue.at ?? 0));
      if (ms < item.startMs || ms >= item.endMs) continue;
      const key = `${ms}:${cue.name}`;
      const gain = Number.isFinite(cue.gain) ? cue.gain : 1;
      const hit = out.get(key);
      if (hit) hit.gain = Math.max(hit.gain, gain);
      else out.set(key, { ms, name: cue.name, gain, itemId: item.id });
    }
  }
  return [...out.values()].sort((a, b) => a.ms - b.ms || a.name.localeCompare(b.name));
}

/** その時刻より後ろのきっかけ（プレビューの先読み） */
export const cuesBetween = (cues = [], fromMs, toMs) => cues.filter((c) => c.ms >= fromMs && c.ms < toMs);

/** 使う音の名前（素材を先に取ってくるのに使う） */
export const cueNames = (cues = []) => [...new Set(cues.map((c) => c.name))];
